var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedinSocial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 800,
    viewBox: "0 0 800 800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_51404_1950)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M400 0C179.063 0 0 179.063 0 400C0 620.938 179.063 800 400 800C620.938 800 800 620.938 800 400C800 179.063 620.938 0 400 0ZM288.125 567.344H210.156V317.812H288.125V567.344ZM247.031 286.562H246.406C218.125 286.562 199.844 267.5 199.844 243.281C199.844 218.594 218.75 200 247.5 200C276.25 200 293.906 218.594 294.531 243.281C294.688 267.344 276.406 286.562 247.031 286.562ZM600 567.344H511.562V438.281C511.562 404.531 497.812 381.406 467.344 381.406C444.062 381.406 431.094 397.031 425.156 412.031C422.969 417.344 423.281 424.844 423.281 432.5V567.344H335.625C335.625 567.344 336.719 338.594 335.625 317.812H423.281V357.031C428.438 339.844 456.406 315.469 501.094 315.469C556.562 315.469 600 351.406 600 428.594V567.344Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_51404_1950"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 800,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinSocial);
export default __webpack_public_path__ + "static/media/linkedin-social.c5299151541074b45c41b412704b7fd4.svg";
export { ForwardRef as ReactComponent };